import React, { Fragment } from "react";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import Link from "@material-ui/core/Link";
import CardFooter from "components/Card/CardFooter.js";

import img from "assets/img/undraw_Notify_re_65on.png";
import logo from "assets/img/logo192.png";

import { makeStyles } from "@material-ui/core/styles";

import { cardStyle } from "assets/jss/material-dashboard-react/components/cardStyle";

const useStyles = makeStyles(cardStyle);

export default function Nofoundpage(props) {
  const classes = useStyles();

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={12} md={12}>
          <center>
            <GridItem xs={12} md={8}>
              <Card>
                <center>
                  <img
                    src={logo}
                    alt="validate"
                    style={{
                      marginTop: 20,
                      width: 140,
                      height: 90,
                      objectFit: "cover",
                    }}
                  />
                </center>

                <CardBody>
                  <Avatar alt="404" src={img} className={classes.img404} />
                  <br></br>
                  <br></br>
                  <div className={classes.titleCard}>Página no encontrada</div>
                  <br></br>
                  <br></br>
                  <Link
                    href="/login"
                    color="inherit"
                    className={classes.blockReds}
                  >
                    <Button className={classes.buttonSubmit}>
                      Ir al inicio
                    </Button>
                  </Link>
                </CardBody>
                <CardFooter> </CardFooter>
              </Card>
            </GridItem>
          </center>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
}
